/*
  Print / Save as PDF for the compliance declaration modal on the product page.

  The modal is moved to <body> by ModalDialog, so a copy of the document is appended
  straight to <body> and everything else is hidden in @media print (see
  assets/component-pdp-declaration.css). Printing an iframe instead is unreliable on
  iOS Safari, and printing the modal in place gets clipped by its scroll container.
*/
(function () {
  var PRINTING_CLASS = 'pdp-decl-printing';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character];
    });
  }

  function cleanup() {
    document.body.classList.remove(PRINTING_CLASS);
    var area = document.querySelector('.pdp-decl-print');
    if (area) area.remove();
  }

  // The copied <img> elements start empty even when the originals are cached, and an
  // image that is still loading prints as a blank box.
  function whenImagesReady(area, done) {
    var pending = Array.prototype.filter.call(area.querySelectorAll('img'), function (image) {
      return !image.complete;
    });
    if (!pending.length) {
      done();
      return;
    }

    var settled = false;
    var remaining = pending.length;

    function settle() {
      if (settled) return;
      settled = true;
      done();
    }

    function tick() {
      remaining -= 1;
      if (remaining <= 0) settle();
    }

    pending.forEach(function (image) {
      image.addEventListener('load', tick, { once: true });
      image.addEventListener('error', tick, { once: true });
    });
    setTimeout(settle, 1500);
  }

  function printDeclaration(dialog) {
    var doc = dialog.querySelector('[data-decl-doc]');
    if (!doc || typeof window.print !== 'function') return;

    cleanup();

    var title = dialog.getAttribute('data-decl-title') || '';
    var product = dialog.getAttribute('data-decl-product') || '';
    var footnote = dialog.getAttribute('data-decl-foot') || '';
    var area = document.createElement('div');
    area.className = 'pdp-decl-print';
    area.setAttribute('aria-hidden', 'true');
    area.setAttribute('inert', '');
    area.innerHTML =
      '<div class="pdp-decl-print__head">' +
      (title ? '<h1>' + escapeHtml(title) + '</h1>' : '') +
      (product ? '<p>' + escapeHtml(product) + '</p>' : '') +
      '</div>' +
      '<div class="pdp-decl-print__doc">' +
      doc.innerHTML +
      '</div>' +
      (footnote ? '<p class="pdp-decl-print__foot">' + escapeHtml(footnote) + '</p>' : '');

    document.body.appendChild(area);
    document.body.classList.add(PRINTING_CLASS);
    whenImagesReady(area, function () {
      window.print();
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var printButton = target.closest('[data-decl-print]');
    if (printButton) {
      var dialog = printButton.closest('[data-decl-dialog]');
      if (dialog) printDeclaration(dialog);
      return;
    }

    var closeButton = target.closest('[data-decl-close]');
    if (closeButton) {
      var modal = closeButton.closest('modal-dialog');
      if (modal && typeof modal.hide === 'function') modal.hide();
    }
  });

  window.addEventListener('afterprint', cleanup);
  document.body.addEventListener('modalClosed', cleanup);

  // Safari doesn't always fire afterprint.
  if (window.matchMedia) {
    var printQuery = window.matchMedia('print');
    if (printQuery.addEventListener) {
      printQuery.addEventListener('change', function (event) {
        if (!event.matches) cleanup();
      });
    }
  }
})();
